<template>
  <form @submit.prevent="postNewJob">
    <div>
      <ValidationObserver v-slot="{ invalid }">
        <h1 class="fw-600 fs-30 text__dark-grey mb-2">Enter Job Details</h1>
        <div
          class="grid grid__layout grid__mobile col-gap-6 row-gap-2 mb-4 pb-6 bb-1"
        >
          <div class="col-6 m-col-12">
            <p class="mb-1 fs-14 fw-600 text__dark-grey">Job Type</p>
            <Dropdown
              :options="jobTypes"
              @selected="updateSelected"
              placeholder="Full Time, Part Time"
              :border="true"
            />
          </div>
          <div class="col-6 m-col-12">
            <p class="mb-1 fs-14 fw-600 text__dark-grey">Job Title</p>
            <Input
              type="text"
              placeholder="Job Position"
              v-model="formData.job_title"
              name="Job Title"
              rules="required"
            />
          </div>
          <div class="col-6 m-col-12">
            <p class="mb-1 fs-14 fw-600 text__dark-grey">Experience</p>
            <Input
              type="text"
              placeholder="e.g 2 to 3yrs"
              v-model="formData.experience"
              name="Job Title"
              rules="required"
            />
          </div>
          <div class="col-6 m-col-12">
            <p class="mb-1 fs-14 fw-600 text__dark-grey">
              Salary Range (
              <svg
                width="13"
                height="10"
                viewBox="0 0 13 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.21151 10C9.03672 10 8.87801 9.9749 8.74001 9.92584C8.60287 9.87764 8.47153 9.79863 8.35033 9.69181C8.2284 9.58471 8.11211 9.4565 8.00611 9.31047C7.89808 9.16158 7.79006 9.00998 7.68565 8.85981L6.2542 6.69866H3.83037V8.91472C3.83037 9.2741 3.7458 9.54763 3.57927 9.72889C3.411 9.91115 3.20117 9.99971 2.93805 9.99971C2.66566 9.99971 2.4541 9.91015 2.29089 9.72604C2.12798 9.54307 2.04544 9.26996 2.04544 8.91472V6.69866H0.658162C0.295268 6.69866 0 6.40787 0 6.05048C0 5.6931 0.295268 5.40231 0.658162 5.40231H2.04544V4.29606H0.658162C0.295268 4.29621 0 4.00542 0 3.64817C0 3.29093 0.295268 3 0.658162 3H2.04544V1.38477C2.04544 1.07259 2.07991 0.827296 2.14782 0.656018C2.23268 0.457787 2.3662 0.304621 2.55821 0.182259C2.75023 0.0596121 2.95195 0 3.17481 0C3.34699 0 3.49644 0.0276669 3.61808 0.0825728C3.74305 0.138762 3.84891 0.21178 3.94187 0.305762C4.03658 0.401169 4.13447 0.526383 4.23323 0.67741C4.33474 0.832858 4.43944 0.994723 4.55051 1.16757L5.78024 3H8.49485V1.08528C8.49485 0.72105 8.57406 0.445807 8.73016 0.266828C8.88685 0.087279 9.09306 0 9.36038 0C9.63667 0 9.84853 0.0874216 10.0075 0.267256C10.1658 0.446092 10.2459 0.721477 10.2459 1.08528V3H11.6495C12.0124 3 12.3077 3.29079 12.3077 3.64817C12.3077 4.00556 12.0124 4.29621 11.6495 4.29621H10.2459V5.4026H11.6495C12.0124 5.4026 12.3077 5.69324 12.3077 6.05077C12.3077 6.40816 12.0124 6.69866 11.6495 6.69866H10.2459V8.76184C10.2459 9.59498 9.90761 10 9.21151 10ZM3.61315 6.27082H6.37193C6.4452 6.27082 6.5137 6.30733 6.55381 6.3678L8.04709 8.62236C8.14672 8.7664 8.25359 8.91543 8.35945 9.06175C8.44691 9.18169 8.54133 9.28637 8.64009 9.37307C8.71959 9.44324 8.80242 9.49372 8.88728 9.52353C8.97837 9.55619 9.08726 9.57245 9.21165 9.57245C9.46464 9.57245 9.8116 9.57245 9.8116 8.76198V6.48474C9.8116 6.36666 9.90906 6.27082 10.0288 6.27082H11.6497C11.7732 6.27082 11.8734 6.17199 11.8734 6.05048C11.8734 5.92898 11.7732 5.83015 11.6497 5.83015H10.0287C9.90877 5.83015 9.81146 5.73431 9.81146 5.61623V4.08229C9.81146 3.9642 9.90877 3.86837 10.0287 3.86837H11.6495C11.7729 3.86837 11.8733 3.76968 11.8733 3.64817C11.8733 3.52667 11.7729 3.42784 11.6495 3.42784H10.0287C9.90877 3.42784 9.81146 3.332 9.81146 3.21392V1.08528C9.81146 0.764404 9.73992 0.616087 9.67968 0.54806C9.62712 0.488448 9.54819 0.427695 9.36038 0.427695C9.21976 0.427695 9.13273 0.46178 9.05975 0.545493C9.00052 0.613805 8.92957 0.762693 8.92957 1.08514V3.21378C8.92957 3.33186 8.83225 3.4277 8.71235 3.4277H5.66338C5.59039 3.4277 5.52219 3.39161 5.48207 3.33172L4.18588 1.40003C4.07278 1.22461 3.96866 1.06361 3.86773 0.909013C3.7849 0.781945 3.70511 0.679549 3.63068 0.604535C3.57579 0.548774 3.5128 0.505562 3.4375 0.47162C3.37393 0.442955 3.28284 0.427695 3.17481 0.427695C3.03652 0.427695 2.91575 0.463776 2.7944 0.541215C2.67623 0.616657 2.59862 0.704364 2.55025 0.817028C2.52534 0.879777 2.47987 1.04549 2.47987 1.38477V3.21378C2.47987 3.33186 2.38256 3.4277 2.26266 3.4277H0.658162C0.534783 3.42784 0.43443 3.52667 0.43443 3.64817C0.43443 3.76968 0.534783 3.86837 0.658162 3.86837H2.26266C2.38256 3.86837 2.47987 3.9642 2.47987 4.08229V5.61637C2.47987 5.73445 2.38256 5.83029 2.26266 5.83029H0.658162C0.534783 5.83015 0.43443 5.92912 0.43443 6.05048C0.43443 6.17185 0.534783 6.27082 0.658162 6.27082H2.26266C2.38256 6.27082 2.47987 6.36666 2.47987 6.48474V8.91472C2.47987 9.15987 2.52766 9.34313 2.61788 9.44452C2.69709 9.53394 2.79266 9.57216 2.93805 9.57216C3.0775 9.57216 3.17279 9.53323 3.25736 9.44139C3.34786 9.34327 3.39594 9.16101 3.39594 8.91514V6.48474C3.39594 6.36666 3.49325 6.27082 3.61315 6.27082ZM8.71206 7.97133C8.64052 7.97133 8.57174 7.93625 8.53076 7.87521L7.67696 6.60254C7.63308 6.53679 7.62917 6.45251 7.66726 6.38334C7.7052 6.31403 7.7789 6.27082 7.85826 6.27082H8.71206C8.83196 6.27082 8.92928 6.36666 8.92928 6.48474V7.75742C8.92928 7.85182 8.86614 7.93511 8.77462 7.96235C8.75391 7.96834 8.73277 7.97133 8.71206 7.97133ZM8.26214 6.69866L8.49485 7.04549V6.69866H8.26214ZM8.71206 5.83015H7.27555C7.20256 5.83015 7.13436 5.79407 7.09424 5.73417L6.06508 4.20009C6.02091 4.13434 6.017 4.05006 6.05494 3.98075C6.09288 3.91158 6.16645 3.86823 6.24609 3.86823H8.71206C8.83196 3.86823 8.92928 3.96406 8.92928 4.08214V5.61623C8.92928 5.73445 8.83196 5.83015 8.71206 5.83015ZM7.39241 5.40231H8.49485V4.29606H6.64997L7.39241 5.40231ZM5.7966 5.83015H3.61315C3.49325 5.83015 3.39594 5.73431 3.39594 5.61623V4.08229C3.39594 3.9642 3.49325 3.86837 3.61315 3.86837H4.78076C4.85403 3.86837 4.92253 3.90488 4.96264 3.96549L5.97863 5.49957C6.02221 5.56532 6.02554 5.64917 5.98775 5.7182C5.94966 5.78736 5.87639 5.83015 5.7966 5.83015ZM3.83037 5.40231H5.39562L4.66303 4.29606H3.83037V5.40231ZM4.20543 3.42798H3.61315C3.49325 3.42798 3.39594 3.33214 3.39594 3.21406V2.31974C3.39594 2.22504 3.45908 2.14161 3.55118 2.11466C3.64313 2.08785 3.74261 2.1235 3.79504 2.2028L4.38731 3.09712C4.4309 3.16286 4.43452 3.24686 4.39658 3.31589C4.35849 3.38477 4.28522 3.42798 4.20543 3.42798Z"
                  fill="black"
                />
              </svg>
              )
            </p>
            <Input
              type="text"
              placeholder="e.g 100K to 300K"
              v-model="formData.salary_range"
              name="Job Title"
              rules="required"
            />
          </div>
          <div class="col-6 m-col-12 z-22">
            <p class="mb-1 fs-14 fw-600 text__dark-grey">Industry</p>
            <selection-box
              label="Type in to search or add new"
              :options="industry"
              type="search-box"
              selection-box-type="secondary"
            />
          </div>
          <div class="col-6 m-col-12">
            <p class="mb-1 fs-14 fw-600 text__dark-grey">
              Education / Qualification
            </p>
            <Input
              type="text"
              placeholder="Select qualification"
              v-model="formData.qualification"
              name="Qualification"
              rules="required"
            />
          </div>
          <div class="col-6 m-col-12">
            <p class="mb-1 fs-14 fw-600 text__dark-grey">Job Category</p>
            <Dropdown
              :options="jobCategories"
              @selected="updateSelected"
              placeholder="Remote, Onsite, Hybrid"
              :border="true"
            />
          </div>
          <div class="col-6 m-col-12">
            <p class="mb-1 fs-14 fw-600 text__dark-grey">Skills</p>
            <selection-box
              class="mb-3"
              label="Type in to search or add new"
              :options="industry"
              type="search-box"
              selection-box-type="secondary"
            />
          </div>
          <div class="col-12 m-col-12">
            <p class="mb-1 fs-14 fw-600 text__dark-grey">Job Description</p>
            <textarea
              class="p-2 h-16"
              placeholder="Enter Job Description"
              v-model="formData.description"
            ></textarea>
          </div>
        </div>

        <div>
          <h1 class="fw-600 fs-30 text__dark-grey mb-2">Company Details</h1>

          <div
            class="grid grid__layout grid__mobile col-gap-6 row-gap-2 mb-3 pb-3 bb-1"
          >
            <div class="col-6">
              <p class="mb-1 fs-14 fw-600 text__dark-grey">Company Name</p>
              <Input
                type="text"
                placeholder="Enter recruiter name"
                v-model="formData.company_name"
                name="Company name"
                rules="required"
              />
            </div>
            <div class="col-6">
              <p class="mb-1 fs-14 fw-600 text__dark-grey">Website</p>
              <Input
                type="text"
                placeholder="Company website"
                v-model="formData.website"
                name="Company website"
                rules="required"
              />
            </div>
            <div class="col-6">
              <p class="mb-1 fs-14 fw-600 text__dark-grey">Location</p>
              <Input
                type="text"
                placeholder="Enter location"
                v-model="formData.location"
                name="Location"
                rules="required"
              />
            </div>
            <div class="col-6">
              <p class="mb-1 fs-14 fw-600 text__dark-grey">No of Openings</p>
              <Input
                type="number"
                placeholder="Enter available position"
                v-model="formData.no_of_openings"
                name="No. of Openings"
                rules="required"
              />
            </div>
            <div class="col-12 mt-1">
              <FileGrabber
                v-model="formData.document"
                insideText="Upload company logo"
                :accept="['.png', '.jpg']"
              />
            </div>
          </div>

          <div class="flex flex-end flex__gap-3">
            <Button class="w-23" theme="plain" @click="$emit('close-modal')"
              >Cancel</Button
            >
            <!-- <Button
                            class="w-23"
                            theme="blue"
                            :loading="loading"
                            :disabled="invalid || loading"
                            >Post Job</Button
                        > -->
            <Button class="w-23" theme="blue" :loading="loading"
              >Post Job</Button
            >
          </div>
        </div>
      </ValidationObserver>
    </div>
  </form>
</template>

<script>
import SelectionBox from "@/components/SelectionBox";
import FileGrabber from "@/components/FileGrabber";

import adminService from "../../../../../../services/api/adminService";

export default {
  name: "CreateJob",
  components: {
    SelectionBox,
    FileGrabber
  },
  data() {
    return {
      formData: {},
      jobTypes: [
        { name: "Full Time", label: "full_time" },
        { name: "Part Time", label: "part_time" }
      ],
      industry: [
        { name: "Fintech", label: "fintech" },
        { name: "HealthCare", label: "health_care" }
      ],
      skills: [
        { name: "Node", label: "node" },
        { name: "Python", label: "python" },
        { name: "Javascript", label: "javascript" }
      ],
      jobCategories: [
        { name: "On Site", label: "on_site" },
        { name: "Hybrid", label: "hybrid" },
        { name: "Remote", label: "remote" }
      ],
      loading: false
    };
  },
  methods: {
    updateSelected(value) {
      console.log(value);
    },
    postNewJob() {
      console.log(this.formData);
      this.loading = true;
      adminService
        .postNewJob(this.formData)
        .then((res) => {
          console.log(res.data);
        })
        .catch((e) => {})
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped></style>
